import styled, { css } from 'styled-components';

import { Flexer } from '@ontruck/orc';
import { Spacer } from '@ontruck/orc';

const StyledHeader = styled(Flexer.Parent).attrs(() => ({ alignItems: 'center' }))``;

const blockStyles = ({ cellWidth, fullHeight, grow }) => css`
  ${cellWidth &&
  `
    width: ${cellWidth}px;
    min-width: ${cellWidth}px;
  `};
  ${fullHeight &&
  `
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    line-height: 1.3;
  `}
  ${grow &&
  `
      flex: 1;
    `}
`;

const textStyles = ({ textAlign = 'left' }) => css`
  text-align: ${textAlign};
`;

const StyledHeaderCell = styled(Spacer).attrs(() => ({
  mRight: 'S',
}))`
  font-size: ${(props) => props.theme.base.textSizes.M};
  color: var(--greyWolf);
  ${blockStyles}
  ${textStyles}
`;

export { StyledHeader, StyledHeaderCell };
